import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FlightSearchAirlineCodes, FlightSearchAirports } from '../Models/FlightSearchProperties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { OfflineBookingMessageStatusUpdate, ChatForm, ChatMessages, FlightRoute, OfflineBookingRequest, OfflineBookingRequestGet, OfflineBookingRejection, OfflineBookingRequestObject, SuppliersCurrency, OfflineBookingSuppliersAccessCodeProperties } from '../Models/OfflineBookingRequestProperties';
import { SegmentTypeList, TicketSuppliersProperties } from '../Models/GroupTicketProperties';
import { faPlaneArrival, faPlaneDeparture } from '@fortawesome/free-solid-svg-icons';
import { OfflineBookingRequestService } from '../Services/OfflineBookingRequest.service';
import { Router } from '@angular/router';
import { saveAs as importedSaveAs } from "file-saver";
import { OfflineBookingPassengerDetails, OfflineBookingProperties, OfflineBookingTripDetails, OfflineBookingWrapper } from '../Models/OfflineBookingProperties';
import { GroupTicketService } from '../Services/groupTicket.service';
import { ActiveCountries } from '../Models/ActiveClasses';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { OfflineRequestService } from '../Services/offline-request.service';
import { PassengerProfile } from '../Models/BookingPassengerTicketIssuanceProperties';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SuppliersService } from '../Services/suppliers.service';
import { Subscription, interval } from 'rxjs';
import { Location } from '@angular/common';
import { time } from 'console';

export class FileView extends File {
  showImage: SafeUrl;
}
export class FileViewMultipleByPass {
  fileView: FileView[] = [];
}
@Component({
  selector: 'app-offlineBookingRequest',
  templateUrl: './offlineBookingRequest.component.html',
  styleUrls: ['./offlineBookingRequest.component.css']
})
export class OfflineBookingCreateComponent implements OnInit {
  airportList: FlightSearchAirports[] = [];
  airLineData: FlightSearchAirlineCodes[] = [];
  filteredAirportsOW: string[] = [];
  offlineBookingCreate = new OfflineBookingRequest();
  chatForm = new ChatForm();
  tripTypeList: SegmentTypeList[] | undefined;
  cabinClassList: any[] | undefined;
  fareTypeList: any[] | undefined;
  adultList: any[] | undefined;
  childList: any[] | undefined;
  infantList: any[] | undefined;
  offlineBookingCreateSubmitted: boolean = false;
  currentDate: any;
  hideReturnDate: boolean = false;
  hideMulticity: boolean = false;
  faCoffee = faPlaneDeparture;
  faCoffee1 = faPlaneArrival;
  loaderVar = false;
  loaderSaveVar = false;
  loaderConfimVar = false;
  buttonDisabled = false;
  buttonSaveDisabled = false;
  disabledField = false;
  newChatForm = new FormData();
  attachedFileName: string[] = [];
  bookingMessageStatusUpdate = new OfflineBookingMessageStatusUpdate();
  offlineBookingParam = new OfflineBookingRequestGet();
  chatMessages: ChatMessages[] = [];
  loginUserId: number = 0;
  primeShowModalApproveModel: boolean = false;
  primeShowModalProposal: boolean = false;
  primeShowModalPaxInfo: boolean = false;
  primeShowModalReject: boolean = false;
  offlineBookingWrapper = new OfflineBookingWrapper();
  bookingProperties = new OfflineBookingProperties();
  offlineBookingOnewayTrip: OfflineBookingTripDetails[] = [];
  offlineBookingReturnTrip: OfflineBookingTripDetails[] = [];
  offlineBookingMulticityTrip: OfflineBookingTripDetails[][] = [];
  offlineBookingPassengerDetails: OfflineBookingPassengerDetails[] = [];
  offlineBookingBasicInformationSubmited: boolean = false;
  ticketSupplierList: TicketSuppliersProperties[] | undefined;
  accessCodeDisabled: boolean = true;
  showofflineBookingProposalSection: boolean = false;
  showofflineBookingBasicInformationSection: boolean = false;
  showSegmentDetailsSection: boolean = false;
  oneWayBookingSegmentSection: boolean = false;
  returnBookingSegmentSection: boolean = false;
  multicityBookingSegmentSection: boolean = false;
  offlineBookingSegmentSubmitted: boolean = false;
  showPassengerDetailsSection: boolean = false;
  offlineBookingPassengerSubmitted: boolean = false;
  rbdTypeList: any[] | undefined;
  passengerTypeList: any[] | undefined;
  passengerTitleList: any[] | undefined;
  passengerGenderList: any[] | undefined;
  countryList: ActiveCountries[] | undefined;
  disableFeildForClient: boolean = false;
  searchprofileCred: PassengerProfile[];
  offlineBookingRejection = new OfflineBookingRejection();
  offlineBookingRejectionSubmited: boolean = false;
  startDisabled: boolean = true;
  grandTotal: number = 0;
  showSavePassengerButton: boolean = false;
  showTicketNumberField: boolean = false;
  showPassengerSectionToManager: boolean = false;
  disabledFinalFields: boolean = false;
  showBookingRequestBasicInfoSection: boolean = true;
  showBookingRequestPassengerSection: boolean = false;
  offlineBookingRequestPassengerSubmitted: boolean = false;
  requestGrandTotal: number = 0;
  disabledRequestAmountField: boolean = false;
  private setIntervalToFetchData: Subscription;
  offlineBookingRequestPassengers: OfflineBookingPassengerDetails[] = [];
  previewFileList: FileViewMultipleByPass[] = [];
  offlineBookingRequestFares = new OfflineBookingWrapper();
  offlineBookingRequestObject = new OfflineBookingRequestObject();
  suppliersCurrencyList: SuppliersCurrency[] | undefined;
  ticketSupplierAccessCodeList: OfflineBookingSuppliersAccessCodeProperties[] | undefined;
  dobDifference: number = 0;
  disabledFieldRevenue: boolean = false;
  chatButtonDisabeld: boolean = false;
  offlineBookingRequestStatus: number;
  offlineBookingRequestOpenByManager: string;
  clearSetTimeOut: any;
  @ViewChild('scrollMe', { static: false }) private myScrollContainer: ElementRef;
  constructor(private flightService: FlightSearchService, private requestService: OfflineBookingRequestService,
    private router: Router, private ticketService: GroupTicketService, private userService: PassengerInfoService,
    private offlineService: OfflineRequestService, private senetizer: DomSanitizer, private supplierService: SuppliersService,
    private previousLocation: Location) {

  }
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {

    if ((this.offlineBookingRequestOpenByManager != null && this.offlineBookingRequestOpenByManager != undefined && this.offlineBookingRequestOpenByManager == "True")
    ) {
      if (this.offlineBookingCreate.requestStatus == 2) {
        this.offlineBookingRequestStatus = 1;
        this.requestService.UpdateOfflineBookingRequestTag(this.offlineBookingCreate.offlineBookingRequestId, this.offlineBookingRequestStatus).subscribe(() => {
          this.offlineBookingRequestStatus = null;

        })
      }
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    if ((this.offlineBookingRequestOpenByManager != null && this.offlineBookingRequestOpenByManager != undefined && this.offlineBookingRequestOpenByManager == "True")
    ) {
      if (this.offlineBookingCreate.requestStatus == 2) {
        this.offlineBookingRequestStatus = 1;
        this.requestService.UpdateOfflineBookingRequestTag(this.offlineBookingCreate.offlineBookingRequestId, this.offlineBookingRequestStatus).subscribe(() => {
          this.offlineBookingRequestStatus = null;

        })
      }
    }
  }
  ngOnInit(): void {
    this.loginUserId = Number(localStorage.getItem("UserId"));
    this.CurrentDate()
    this.tripTypeList = [
      { segmentTypeId: 1, segmentTypeName: "OneWay" }, { segmentTypeId: 2, segmentTypeName: "Return" }, { segmentTypeId: 3, segmentTypeName: "Multicity" }
    ];
    this.cabinClassList = [
      { cabinItem: "Economy" }, { cabinItem: "Business" }, { cabinItem: "First" }, { cabinItem: "PremiumEconomy" },
    ];

    this.fareTypeList = [
      { fareItem: "Low Fares" }, { fareItem: "Refundable" }, { fareItem: "Non-Refundable" },
    ];
    this.rbdTypeList = [
      { rbdType: "A" }, { rbdType: "B" }, { rbdType: "C" }, { rbdType: "D" }, { rbdType: "E" }, { rbdType: "F" },
      { rbdType: "G" }, { rbdType: "H" }, { rbdType: "I" }, { rbdType: "J" }, { rbdType: "K" }, { rbdType: "L" },
      { rbdType: "M" }, { rbdType: "N" }, { rbdType: "O" }, { rbdType: "P" }, { rbdType: "Q" }, { rbdType: "R" },
      { rbdType: "S" }, { rbdType: "T" }, { rbdType: "U" }, { rbdType: "V" }, { rbdType: "W" }, { rbdType: "X" },
      { rbdType: "Y" }, { rbdType: "Z" }, { rbdType: "All" },

    ];
    this.passengerTypeList = [
      { passengerTypeId: 1, passengerTypeName: "Adult" }, { passengerTypeId: 2, passengerTypeName: "Child" },
      { passengerTypeId: 3, passengerTypeName: "Infant" }
    ];
    this.passengerTitleList = [
      { passengerTitleName: "Mr" }, { passengerTitleName: "Mrs" }, { passengerTitleName: "Miss" }
    ];
    this.passengerGenderList = [
      { passengerGenderName: "Male" }, { passengerGenderName: "Female" }
    ];
    this.GetSearchBaseData();
    this.AddPassengerNumbers();
    this.GetBookingBaseData();
    this.GetSupplierCurrencies();
  }
  public AddPassengerNumbers = (): void => {
    this.adultList = [];
    this.childList = [];
    this.infantList = [];
    for (let i: number = 0; i <= 9; i++) {
      let adultItmes: any = new Object();
      adultItmes.adultItem = i;
      this.adultList.push(adultItmes);
    }
    for (let i: number = 0; i <= 9; i++) {
      let childItmes: any = new Object();
      childItmes.childItem = i;
      this.childList.push(childItmes);
    }
    for (let i: number = 0; i <= 1; i++) {
      let infantItems: any = new Object();
      infantItems.infantItem = i;
      this.infantList.push(infantItems);
    }
  }
  private GetSupplierCurrencies = (): void => {
    this.supplierService.GetSupplierCurrencies().subscribe(data => {
      this.suppliersCurrencyList = data;
    });
  }
  public GetSearchBaseData = (): void => {
    try {
      let offlineBookingRequest = Number(localStorage.getItem("OfflineBookingRequestID"));
      if (offlineBookingRequest != null && offlineBookingRequest != undefined && offlineBookingRequest > 0) {
        this.offlineBookingRequestOpenByManager = localStorage.getItem("OfflineBookingRequestOpenBy");
        // let offlineBookingRequestOpenBy = localStorage.getItem("OfflineBookingRequestOpenBy");
        this.offlineBookingParam.offlineBookingRequestID = offlineBookingRequest;
        if (this.offlineBookingRequestOpenByManager != null && this.offlineBookingRequestOpenByManager != undefined && this.offlineBookingRequestOpenByManager == "True") {
          this.offlineBookingParam.statusOpen = true;
          this.offlineBookingParam.managerId = Number(localStorage.getItem("UserId"));
          this.OfflineBookingRequestGet(this.offlineBookingParam);

        }
        else {
          this.offlineBookingParam.statusOpen = false;
          this.offlineBookingParam.managerId = 0;
          this.OfflineBookingRequestGet(this.offlineBookingParam);
        }

      }

      this.setIntervalToFetchData = interval(10000).subscribe(() => {
        if (offlineBookingRequest != null && offlineBookingRequest != undefined && offlineBookingRequest > 0) {
          this.OfflineBookingRequestGetRefresh(this.offlineBookingParam);
          // this.disabledFieldRevenue = false;
        }
      });

      this.flightService.GetFlightBaseData().subscribe((data) => {
        this.airLineData = data.airlines;
        this.airportList = data.airports;
        if (this.offlineBookingCreate.offlineBookingRequestId == 0) {

          let flightRoutes = new FlightRoute();
          this.offlineBookingCreate.flightRoute.push(flightRoutes);
        }
      });
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });



    }
    catch (e) {
      console.log(e)
    }
  }

  ngOnDestroy(): void {
    if (this.clearSetTimeOut) {
      clearTimeout(this.clearSetTimeOut)
    }
    if (this.setIntervalToFetchData) {
      this.setIntervalToFetchData.unsubscribe();
    }
    if ((this.offlineBookingRequestOpenByManager != null && this.offlineBookingRequestOpenByManager != undefined && this.offlineBookingRequestOpenByManager == "True")) {
      if (this.offlineBookingCreate.requestStatus == 2) {
        this.offlineBookingRequestStatus = 1;
        this.requestService.UpdateOfflineBookingRequestTag(this.offlineBookingCreate.offlineBookingRequestId, this.offlineBookingRequestStatus).subscribe(() => {
          this.offlineBookingRequestStatus = null;

        })
      }
    }
  }
  // public BookingRequestFormFocus = (): void => {
  //   if (this.setIntervalToFetchData) {
  //     this.setIntervalToFetchData.unsubscribe();
  //   }
  // }
  // public BookingRequestFormBlur = (): void => {
  //   this.setIntervalToFetchData = interval(60000).subscribe(() => {
  //     if (this.offlineBookingCreate.offlineBookingRequestId > 0) {
  //       this.disabledFieldRevenue = false;
  //       this.offlineBookingParam.managerId = 0;
  //       this.offlineBookingParam.statusOpen = false;
  //       this.offlineBookingParam.offlineBookingRequestID = this.offlineBookingCreate.offlineBookingRequestId;
  //       this.OfflineBookingRequestGet(this.offlineBookingParam);
  //     }
  //   });
  // }

  private OfflineBookingRequestGetRefresh = (offlineBookingRequest: OfflineBookingRequestGet): void => {
    this.requestService.OfflineBookingRequestGet(offlineBookingRequest).subscribe(data => {
      this.offlineBookingCreate.requestStatus = data.offlineBookingRequest.requestStatus;
      this.offlineBookingCreate.requestStatusName = data.offlineBookingRequest.requestStatusName;
      // console.log(this.offlineBookingCreate)
      // if (this.offlineBookingCreate.bookingSource != "" && this.offlineBookingCreate.bookingSource != undefined && this.offlineBookingCreate.bookingSource != null) {
      //   this.GetSupplierAccessCodes(this.offlineBookingCreate.bookingSource);
      // }
      this.chatMessages = data.chatMessages;
      if (this.chatMessages.length > 0) {
        this.ScrollerChat();
      }
      // this.offlineBookingRequestPassengers = data.offlineBookingRequestPassengers;
      if (data.offlineBookingRequest.requestStatus > 2) {
        this.disabledRequestAmountField = true;
        this.showBookingRequestBasicInfoSection = true;
        this.showBookingRequestPassengerSection = false;
        if (data.offlineBookingRequest.requestStatus > 6) {
          this.disabledFinalFields = true;
          this.showTicketNumberField = true;
        }
      }

      // if (this.offlineBookingRequestPassengers.length > 0) {
      //   this.requestGrandTotal = 0;
      //   for (let i: number = 0; i < this.offlineBookingRequestPassengers.length; i++) {
      //     this.requestGrandTotal += this.offlineBookingRequestPassengers[i].netTotalAmount;
      //   }
      // }
      // this.offlineBookingWrapper = data.offlineBooking;
      // if (this.offlineBookingWrapper.booking != null && this.offlineBookingWrapper.passengerList != null && this.offlineBookingWrapper.passengerList.length > 0) {
      //   this.disableFeildForClient = true;
      //   this.bookingProperties = this.offlineBookingWrapper.booking;
      //   this.GetSupplierAccessCodes(this.bookingProperties.bookingSource);
      //   this.offlineBookingPassengerDetails = this.offlineBookingWrapper.passengerList;
      //   if (this.offlineBookingPassengerDetails.length > 0) {
      //     this.grandTotal = 0;
      //     for (let i: number = 0; i < this.offlineBookingPassengerDetails.length; i++) {
      //       this.grandTotal += this.offlineBookingPassengerDetails[i].netTotalAmount;
      //     }
      //   }
      //   if (this.offlineBookingWrapper.tripList[0].segmentType == 3) {
      //     this.offlineBookingMulticityTrip.length = this.offlineBookingCreate.flightRoute.length;
      //     let itration: number = 0;
      //     for (let m: number = 0; m < this.offlineBookingCreate.flightRoute.length; m++) {
      //       this.offlineBookingMulticityTrip[m] = []
      //       for (let s: number = itration; s < this.offlineBookingWrapper.tripList.length; s++) {
      //         if (this.offlineBookingCreate.flightRoute[m].arrivalTo != this.offlineBookingWrapper.tripList[s].toAirport) {
      //           this.offlineBookingMulticityTrip[m].push(this.offlineBookingWrapper.tripList[s]);
      //         }
      //         else {
      //           this.offlineBookingMulticityTrip[m].push(this.offlineBookingWrapper.tripList[s]);
      //           itration = s + 1;
      //           break;
      //         }
      //       }
      //     }
      //   }
      //   else {
      //     this.offlineBookingOnewayTrip = [];
      //     this.offlineBookingReturnTrip = [];
      //     for (let s: number = 0; s < this.offlineBookingWrapper.tripList.length; s++) {

      //       if (this.offlineBookingWrapper.tripList[s].departureSegment == true) {
      //         this.offlineBookingOnewayTrip.push(this.offlineBookingWrapper.tripList[s]);
      //       }
      //       if (this.offlineBookingWrapper.tripList[s].returnSegment == true) {
      //         this.offlineBookingReturnTrip.push(this.offlineBookingWrapper.tripList[s]);
      //       }
      //     }
      //   }
      // }

      // this.disabledField = true;
      // // this.HideFormDiv();
      // if (this.offlineBookingCreate.tripType == 2) {
      //   this.offlineBookingCreate.returnDate = this.offlineBookingCreate.flightRoute[1].departureDate;
      //   this.offlineBookingCreate.flightRoute.splice(1, 1);
      //   this.hideReturnDate = true;
      // }
      // localStorage.removeItem("OfflineBookingRequestID");
      // localStorage.removeItem("OfflineBookingRequestOpenBy");
    })
  }
  private OfflineBookingRequestGet = (offlineBookingRequest: OfflineBookingRequestGet): void => {
    this.requestService.OfflineBookingRequestGet(offlineBookingRequest).subscribe(data => {
      this.offlineBookingCreate = data.offlineBookingRequest;
      this.chatMessages = data.chatMessages;
      if (this.chatMessages.length > 0) {
        this.ScrollerChat();
      }
      if (this.offlineBookingCreate.bookingSource != "" && this.offlineBookingCreate.bookingSource != undefined && this.offlineBookingCreate.bookingSource != null) {
        this.GetSupplierAccessCodes(this.offlineBookingCreate.bookingSource);
      }
      
      this.offlineBookingRequestPassengers = data.offlineBookingRequestPassengers;
      if (this.offlineBookingCreate.requestStatus > 2) {
        this.disabledRequestAmountField = true;
        this.showBookingRequestBasicInfoSection = false;
        this.showBookingRequestPassengerSection = true;
        if (this.offlineBookingCreate.requestStatus > 6) {
          this.disabledFinalFields = true;
          this.showTicketNumberField = true;
        }
      }

      if (this.offlineBookingRequestPassengers.length > 0) {
        this.requestGrandTotal = 0;
        for (let i: number = 0; i < this.offlineBookingRequestPassengers.length; i++) {
          this.requestGrandTotal += this.offlineBookingRequestPassengers[i].netTotalAmount;
        }
      }
      this.offlineBookingWrapper = data.offlineBooking;
      if (this.offlineBookingWrapper.booking != null && this.offlineBookingWrapper.passengerList != null && this.offlineBookingWrapper.passengerList.length > 0) {
        this.disableFeildForClient = true;
        this.bookingProperties = this.offlineBookingWrapper.booking;
        this.GetSupplierAccessCodes(this.bookingProperties.bookingSource);
        this.offlineBookingPassengerDetails = this.offlineBookingWrapper.passengerList;
        if (this.offlineBookingPassengerDetails.length > 0) {
          this.grandTotal = 0;
          for (let i: number = 0; i < this.offlineBookingPassengerDetails.length; i++) {
            this.grandTotal += this.offlineBookingPassengerDetails[i].netTotalAmount;
          }
        }
        if (this.offlineBookingWrapper.tripList[0].segmentType == 3) {
          this.offlineBookingMulticityTrip.length = this.offlineBookingCreate.flightRoute.length;
          let itration: number = 0;
          for (let m: number = 0; m < this.offlineBookingCreate.flightRoute.length; m++) {
            this.offlineBookingMulticityTrip[m] = []
            for (let s: number = itration; s < this.offlineBookingWrapper.tripList.length; s++) {
              if (this.offlineBookingCreate.flightRoute[m].arrivalTo != this.offlineBookingWrapper.tripList[s].toAirport) {
                this.offlineBookingMulticityTrip[m].push(this.offlineBookingWrapper.tripList[s]);
              }
              else {
                this.offlineBookingMulticityTrip[m].push(this.offlineBookingWrapper.tripList[s]);
                itration = s + 1;
                break;
              }
            }
          }
        }
        else {
          this.offlineBookingOnewayTrip = [];
          this.offlineBookingReturnTrip = [];
          for (let s: number = 0; s < this.offlineBookingWrapper.tripList.length; s++) {

            if (this.offlineBookingWrapper.tripList[s].departureSegment == true) {
              this.offlineBookingOnewayTrip.push(this.offlineBookingWrapper.tripList[s]);
            }
            if (this.offlineBookingWrapper.tripList[s].returnSegment == true) {
              this.offlineBookingReturnTrip.push(this.offlineBookingWrapper.tripList[s]);
            }
          }
        }
      }

      this.disabledField = true;
      // this.HideFormDiv();
      if (this.offlineBookingCreate.tripType == 2) {
        this.offlineBookingCreate.returnDate = this.offlineBookingCreate.flightRoute[1].departureDate;
        this.offlineBookingCreate.flightRoute.splice(1, 1);
        this.hideReturnDate = true;
      }
      this.clearSetTimeOut = setTimeout(() => {
        if ((this.offlineBookingRequestOpenByManager != null && this.offlineBookingRequestOpenByManager != undefined && this.offlineBookingRequestOpenByManager == "True")) {
          if (this.offlineBookingCreate.requestStatus == 2) {
            this.offlineBookingRequestStatus = 1;
            this.requestService.UpdateOfflineBookingRequestTag(this.offlineBookingCreate.offlineBookingRequestId, this.offlineBookingRequestStatus).subscribe(() => {
              this.offlineBookingRequestStatus = null;
              this.previousLocation.back();
            })
          }
        }
      }, 600000);
      localStorage.removeItem("OfflineBookingRequestID");
      localStorage.removeItem("OfflineBookingRequestOpenBy");
    })
  }
  public AddOfflinePassengerFare = (): void => {
    this.showBookingRequestBasicInfoSection = false;
    this.showBookingRequestPassengerSection = true;
    this.showPassengerSectionToManager = true;
  }
  public ViewOfflinePassengerFare = (): void => {
    this.OfflineBookingRequestGet(this.offlineBookingParam);
    this.AddOfflinePassengerFare();
  }
  public RequestPassengerFileDownload = (filePath: string, index: number): void => {
    let fileTypeArray: string[] = filePath.split('.');
    let fileType: string = fileTypeArray[fileTypeArray.length - 1];
    if (fileType.includes('pdf')) {
      fileType = 'application/pdf';
    } else {
      fileType = 'image/' + fileType;
    }
    this.requestService.OfflineBookingRequestFileDownload(filePath, fileType).subscribe(
      (data: Blob) => {
        importedSaveAs(data, filePath.split('.')[filePath.split('.').length - 2] + "." + fileType.split('/')[1]);
      }
    )
  }
  public filterAirportsOW = (event: any): void => {
    let filteredOW: string[] = [];
    let query = event.query.toLowerCase();
    for (let i: number = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }
    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
  }
  public OnChangeAdult = (value: number): void => {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.offlineBookingCreate.child) > 9) {
          this.offlineBookingCreate.child = this.childList.length;
        };
        for (let i: number = 0; i <= count; i++) {
          let childItmes: any = new Object();
          childItmes.childItem = i;
          this.childList.push(childItmes);
        }


      }
      else {
        for (let i: number = 0; i <= 9; i++) {
          let childItmes: any = new Object();
          childItmes.childItem = i;
          this.childList.push(childItmes);
        }
      }

      this.infantList = [];
      if (value > 0) {
        this.offlineBookingCreate.infant = 0;
        for (let i: number = 0; i < value + 1; i++) {
          let infantItems: any = new Object();
          infantItems.infantItem = i;
          this.infantList.push(infantItems);
        }

      }
      else {
        for (let i: number = 0; i <= 0; i++) {
          let infantItems: any = new Object();
          infantItems.infantItem = i;
          this.infantList.push(infantItems);
        }
      }
    }
    catch (e) {
      console.log(e)
    }
  }
  public OneWayDepartureFromTicket = (fromAirport: string, index: number): void => {
    this.offlineBookingCreate.flightRoute[index].departureFrom = fromAirport.split("-")[0].trim();

  }
  public OneWayDepartureToTicket = (toAirport: string, index: number): void => {
    this.offlineBookingCreate.flightRoute[index].arrivalTo = toAirport.split("-")[0].trim();
  }
  public ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  public CurrentDate = (): void => {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDate = year + "-" + month + "-" + todayDate;

  }
  public DateValidationDepartureTicketDate = (date: any, index: number): void => {
    if (date.target.value == "") {
      this.offlineBookingCreate.flightRoute[index].departureDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingCreate.flightRoute[index].departureDate = this.currentDate;
    }
    else {
      this.offlineBookingCreate.flightRoute[index].departureDate = date.target.value;
    }

  }
  public DateValidationReturnTicketDate = (date: any): void => {
    if (date.target.value == "") {
      this.offlineBookingCreate.returnDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingCreate.returnDate = this.currentDate;
    }
    else {
      this.offlineBookingCreate.returnDate = date.target.value;
    }

  }

  public TripTypeChange = (tripType: number): void => {
    if (tripType == 1) {
      this.hideReturnDate = false;
      this.hideMulticity = false;
      let obj = this.offlineBookingCreate.flightRoute[0];
      this.offlineBookingCreate.flightRoute = [];
      this.offlineBookingCreate.flightRoute.push(obj);

    }
    if (tripType == 2) {
      this.hideReturnDate = true;
      this.hideMulticity = false;
      let obj = this.offlineBookingCreate.flightRoute[0];
      this.offlineBookingCreate.flightRoute = [];
      this.offlineBookingCreate.flightRoute.push(obj);
    }
    if (tripType == 3) {
      this.hideReturnDate = false;
      this.hideMulticity = true;
      let flightRoutes = new FlightRoute();
      this.offlineBookingCreate.flightRoute.push(flightRoutes);
    }
  }
  public AddNewflight = (): void => {
    let flightRoutes = new FlightRoute();
    this.offlineBookingCreate.flightRoute.push(flightRoutes);
  }
  public Removeflight = (index: number): void => {
    this.offlineBookingCreate.flightRoute.splice(index, 1);
  }
  public SubmitBookingRequestBasicInfo = (requestForm: any): boolean => {

    this.offlineBookingCreateSubmitted = true;
    let submitValidation = true;
    if (requestForm.invalid) {
      return false;
    }
    else {
      if (this.offlineBookingCreate.adult == 0 && this.offlineBookingCreate.child == 0) {
        document.getElementById("errorOfflineBookingCreate").innerHTML = "**Please Select Atleast One Adult or Child!";
        document.getElementById("errorOfflineBookingCreate").style.color = "#f44336";
        setTimeout(() => {
          document.getElementById("errorOfflineBookingCreate").innerHTML = "";
          document.getElementById("errorOfflineBookingCreate").style.color = "";
        }, 5000);
        submitValidation = false;
        return false;
      }
      if (this.offlineBookingCreate.adult == 0 && this.offlineBookingCreate.infant > 0) {
        document.getElementById("errorOfflineBookingCreate").innerHTML = "**Please Select Atleast One Adult";
        document.getElementById("errorOfflineBookingCreate").style.color = "#f44336";
        setTimeout(() => {
          document.getElementById("errorOfflineBookingCreate").innerHTML = "";
          document.getElementById("errorOfflineBookingCreate").style.color = "";
        }, 5000);
        submitValidation = false;
        return false;
      }
      if (this.offlineBookingCreate.tripType == 2 && new Date(this.offlineBookingCreate.flightRoute[0].departureDate) > new Date(this.offlineBookingCreate.returnDate)) {
        submitValidation = false;
        return false;
      }
      if (this.offlineBookingCreate.tripType == 3) {
        for (let i: number = 1; i < this.offlineBookingCreate.flightRoute.length; i++) {
          if (this.offlineBookingCreate.flightRoute[i].departureDate <= this.offlineBookingCreate.flightRoute[i - 1].departureDate) {
            submitValidation = false;
            return false;
          }
        }
      }
      if (submitValidation == true) {
        if (this.offlineBookingCreate.offlineBookingRequestId == 0) {
          let count: number = this.offlineBookingCreate.adult + this.offlineBookingCreate.child + this.offlineBookingCreate.infant;
          this.previewFileList.length = count;
          if (this.offlineBookingRequestPassengers.length != count) {
            this.offlineBookingRequestPassengers = [];
          }
          if (this.offlineBookingRequestPassengers.length == 0) {
            this.offlineBookingRequestPassengers = [];
            if (this.offlineBookingCreate.adult > 0) {
              for (let i: number = 0; i < this.offlineBookingCreate.adult; i++) {
                let passenger = new OfflineBookingPassengerDetails();
                passenger.passengerTypeId = 1;
                this.offlineBookingRequestPassengers.push(passenger);
                

              }
            }
            if (this.offlineBookingCreate.child > 0) {
              for (let i: number = 0; i < this.offlineBookingCreate.child; i++) {
                let passenger = new OfflineBookingPassengerDetails();
                passenger.passengerTypeId = 2;
                this.offlineBookingRequestPassengers.push(passenger);
               
              }
            }
            if (this.offlineBookingCreate.infant > 0) {
              for (let i: number = 0; i < this.offlineBookingCreate.infant; i++) {
                let passenger = new OfflineBookingPassengerDetails();
                passenger.passengerTypeId = 3;
                this.offlineBookingRequestPassengers.push(passenger);
              
              }
            }
          }
        }
        this.showBookingRequestBasicInfoSection = false;
        this.showBookingRequestPassengerSection = true;
        if (this.loginUserId == this.offlineBookingCreate.agencyBranchManagerId && this.offlineBookingCreate.offlineBookingRequestId > 0) {
          this.showPassengerSectionToManager = true;
        }
        else if (this.loginUserId == this.offlineBookingCreate.creationUser && this.offlineBookingCreate.requestStatus > 2) {
          this.showPassengerSectionToManager = true;
        }
        else {
          this.showPassengerSectionToManager = false;
        }
      }
    }

  }
  public SetBackToRequestBasicInfo = (): void => {
    this.showBookingRequestBasicInfoSection = true;
    this.showBookingRequestPassengerSection = false;
  }
  public OnPassengerTitleChange = (title: string, index: number): void => {

    if (title == "Mr") {
      this.offlineBookingRequestPassengers[index].paxGender = this.passengerGenderList[0].passengerGenderName;
    }
    else {
      this.offlineBookingRequestPassengers[index].paxGender = this.passengerGenderList[1].passengerGenderName;
    }
  }
  
  paxFiles: FileView[] = [];

  public OnPassengerFileChange = (event: any, eventTrigger: string, index: number): void => {
    event.preventDefault();
    let files: FileList = undefined;
    this.paxFiles = [];
    if (eventTrigger == `drag${index}`) {
      //if (event.dataTransfer.files.length == 0) {
      //  this.previewFileList[index].fileView = [];
      //  this.offlineBookingRequestPassengers[index].files = [];
      //  return;
      //}
      if (eventTrigger == `drag${index}`) {

        files = event.dataTransfer.files;
        for (let i: number = 0; i < event.dataTransfer.files.length; i++) {
          const file: File = event.dataTransfer.files.item(i) as File;
          const safePreview = file as FileView;
          if (file) {
            safePreview.showImage = this.senetizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
            this.paxFiles.push(safePreview);
          }
        }
        if (this.previewFileList[index] == undefined || this.previewFileList[index] == null) {
          this.previewFileList[index] = new FileViewMultipleByPass();
        }
        for (let y = 0; y < this.paxFiles.length; y++) {
          this.previewFileList[index].fileView.push(this.paxFiles[y]);
        }

        files = event.target.files;
        for (let f: number = 0; f < files.length; f++) {
          this.offlineBookingRequestPassengers[index].files.push(files[f]);
        }
      }
    }
    else {
      //if (event.target.files.length == 0) {

      //  this.previewFileList[index].fileView = [];
      //  this.offlineBookingRequestPassengers[index].files = [];
      //  return;
      //}

      if (eventTrigger == `click${index}`) {
        for (let i: number = 0; i < event.target.files.length; i++) {
          const file: File = event.target.files.item(i) as File;
          const safePreview = file as FileView;
          if (file) {
            safePreview.showImage = this.senetizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
            this.paxFiles.push(safePreview);
          }
        }
        if (this.previewFileList[index] == undefined || this.previewFileList[index] == null) {
          this.previewFileList[index] = new FileViewMultipleByPass();
        }

        for (let y = 0; y < this.paxFiles.length; y++) {
          this.previewFileList[index].fileView.push(this.paxFiles[y]);
        }
        files = event.target.files;
        for (let f: number = 0; f < files.length; f++) {
          this.offlineBookingRequestPassengers[index].files.push(files[f]);
        }
      }
    }







  }
  //public OnPassengerFileChange = (event: any, eventTrigger: string, index: number): void => {
  //  event.preventDefault();
  //  let files: FileList = undefined;
  //  if (eventTrigger == `drag${index}`) {
  //    //if (event.dataTransfer.files.length == 0) {
  //    //  this.previewFileList[index].fileView = [];
  //    //  this.offlineBookingRequestPassengers[index].files = [];
  //    //  return;
  //    //}
  //    if (eventTrigger == `drag${index}`) {
      
  //      files = event.dataTransfer.files;
  //      for (let i: number = 0; i < event.dataTransfer.files.length; i++) {
  //        const file: File = event.dataTransfer.files.item(i) as File;
  //        const safePreview = file as FileView;
  //        if (file) {
  //          safePreview.showImage = this.senetizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  //          this.paxFiles.push(safePreview);
  //        }
  //      }
  //      if (this.previewFileList[index] == undefined || this.previewFileList[index] == null) {
  //        this.previewFileList[index] = new FileViewMultipleByPass();
  //      }

  //      this.previewFileList[index].fileView = this.paxFiles;
  //      files = event.target.files;
  //      for (let f: number = 0; f < files.length; f++) {
  //        this.offlineBookingRequestPassengers[index].files.push(files[f]);
  //      }
  //    }
  //  }
  //  else {
  //    //if (event.target.files.length == 0) {
  
  //    //  this.previewFileList[index].fileView = [];
  //    //  this.offlineBookingRequestPassengers[index].files = [];
  //    //  return;
  //    //}
    
  //    if (eventTrigger == `click${index}`) {
  //      for (let i: number = 0; i < event.target.files.length; i++) {
  //        const file: File = event.target.files.item(i) as File;
  //        const safePreview = file as FileView;
  //        if (file) {
  //          safePreview.showImage = this.senetizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  //          this.paxFiles.push(safePreview);
  //        }
  //      }
  //      if (this.previewFileList[index] == undefined || this.previewFileList[index] == null) {
  //        this.previewFileList[index] = new FileViewMultipleByPass();
  //      }
        
  //      this.previewFileList[index].fileView = this.paxFiles;
  //      files = event.target.files;
  //      for (let f: number = 0; f < files.length; f++) {
  //        this.offlineBookingRequestPassengers[index].files.push(files[f]);
  //      }
  //    }
  //  }
   
      
      

      
    
    
  //}
  public ClearSelection = (outerIndex: number, innerIndex: number): void => {
    console.log(outerIndex, innerIndex)
    this.offlineBookingRequestPassengers[outerIndex].files.splice(innerIndex, 1);
    this.previewFileList[outerIndex].fileView.splice(innerIndex, 1);
  }
  public CalculateRequestPassengerTotalAmount = (index: number): void => {
    this.offlineBookingRequestFares.passengerFares = [];
    if (this.offlineBookingRequestPassengers[index].serviceCharges < 0 || this.offlineBookingRequestPassengers[index].serviceCharges == null) {
      this.offlineBookingRequestPassengers[index].serviceCharges = 0
    }
    if (this.offlineBookingRequestPassengers[index].discount < 0 || this.offlineBookingRequestPassengers[index].discount == null) {
      this.offlineBookingRequestPassengers[index].discount = 0
    }
    this.offlineBookingRequestPassengers[index].netTotalAmount
      = (this.offlineBookingRequestPassengers[index].fareValue + this.offlineBookingRequestPassengers[index].tax + this.offlineBookingRequestPassengers[index].serviceCharges
        - this.offlineBookingRequestPassengers[index].discount);

    this.requestGrandTotal = 0;
    for (let i: number = 0; i < this.offlineBookingRequestPassengers.length; i++) {
      this.requestGrandTotal += this.offlineBookingRequestPassengers[i].netTotalAmount;
    }

  }
  public CalculateRequestPassengerTotalAmountRevenue = (index: number): void => {
    if (this.offlineBookingRequestPassengers[index].serviceCharges < 0 || this.offlineBookingRequestPassengers[index].serviceCharges == null) {
      this.offlineBookingRequestPassengers[index].serviceCharges = 0
    }
    if (this.offlineBookingRequestPassengers[index].discount < 0 || this.offlineBookingRequestPassengers[index].discount == null) {
      this.offlineBookingRequestPassengers[index].discount = 0
    }
    this.offlineBookingRequestPassengers[index].netTotalAmount
      = (this.offlineBookingRequestPassengers[index].fareValue + this.offlineBookingRequestPassengers[index].tax + this.offlineBookingRequestPassengers[index].serviceCharges
        - this.offlineBookingRequestPassengers[index].discount);

    this.requestGrandTotal = 0;
    for (let i: number = 0; i < this.offlineBookingRequestPassengers.length; i++) {
      this.requestGrandTotal += this.offlineBookingRequestPassengers[i].netTotalAmount;
    }

  }
  public SubmitOfflineBookingRequestPassengers = (passengerForm: any): boolean => {
    this.offlineBookingRequestPassengerSubmitted = true;
    let offlineBookingPassengerValid: boolean = true;
    if (passengerForm.invalid) {
      document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Filelds!";
      setTimeout(() => {
        document.getElementById("errorReqPassengerSection").innerHTML = "";
      }, 5000);
      return false;
    }
    else {
      for (let i: number = 0; i < this.offlineBookingRequestPassengers.length; i++) {
        if (this.MobileNumberValidateWhenSearch(this.offlineBookingRequestPassengers[i].mobile) == false) {
          offlineBookingPassengerValid = false;
          document.getElementById(`reqpassengerInfoErrorMobileNumber${i}`).innerText = "**Invalid Number Pattern!";
          document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById(`reqpassengerInfoErrorMobileNumber${i}`).innerText = "**Mobile Number Required!";
            document.getElementById("errorReqPassengerSection").innerHTML = "";
          }, 3000);
          return false;
        }
        let currentDate: Date = new Date();
        let dob: Date = new Date(this.offlineBookingRequestPassengers[i].paxDOB);
        this.dobDifference = currentDate.getMonth() - dob.getMonth() +
          (12 * (currentDate.getFullYear() - dob.getFullYear()));
        if ((this.dobDifference < 144 || this.dobDifference > 1200) && this.offlineBookingRequestPassengers[i].passengerTypeId == 1) {
          offlineBookingPassengerValid = false;
          document.getElementById(`reqpassengerInfoErrorpaxDOBs${i}`).innerText = "**Should be Grater Than 12y!";
          document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById(`reqpassengerInfoErrorpaxDOBs${i}`).innerText = "";
            document.getElementById("errorReqPassengerSection").innerHTML = "";
          }, 3000);
          return false;
        }
        if ((this.dobDifference < 24 || this.dobDifference >= 144) && this.offlineBookingRequestPassengers[i].passengerTypeId == 2) {
          offlineBookingPassengerValid = false;
          document.getElementById(`reqpassengerInfoErrorpaxDOBs${i}`).innerText = "**Should be Between 2y to 12y!";
          document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById(`reqpassengerInfoErrorpaxDOBs${i}`).innerText = "";
            document.getElementById("errorReqPassengerSection").innerHTML = "";
          }, 3000);
          return false;
        }
        if ((this.dobDifference < 0 || this.dobDifference >= 24) && this.offlineBookingRequestPassengers[i].passengerTypeId == 3) {
          offlineBookingPassengerValid = false;
          document.getElementById(`reqpassengerInfoErrorpaxDOBs${i}`).innerText = "**Should be Less Than 2y!";
          document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Filelds!";
          setTimeout(() => {
            document.getElementById(`reqpassengerInfoErrorpaxDOBs${i}`).innerText = "";
            document.getElementById("errorReqPassengerSection").innerHTML = "";
          }, 3000);
          return false;
        }
        if (this.offlineBookingCreate.offlineBookingRequestId > 0 && this.showPassengerSectionToManager == true) {
          if (this.offlineBookingRequestPassengers[i].fareValue <= 0) {
            offlineBookingPassengerValid = false;
            document.getElementById("errorReqPassengerSection").innerHTML = "**Values Should Be Grater Than '0'!";
            setTimeout(() => {
              document.getElementById("errorReqPassengerSection").innerHTML = "";
            }, 5000);
            return false;
          }
          if (this.offlineBookingRequestPassengers[i].tax <= 0) {
            offlineBookingPassengerValid = false;
            document.getElementById("errorReqPassengerSection").innerHTML = "**Values Should Be Grater Than '0'!";
            setTimeout(() => {
              document.getElementById("errorReqPassengerSection").innerHTML = "";
            }, 5000);
            return false;
          }
          if (this.offlineBookingCreate.exchangeCurrencyRate <= 0) {
            offlineBookingPassengerValid = false;
            document.getElementById("errorReqPassengerSection").innerHTML = "**Values Should Be Grater Than '0'!";
            setTimeout(() => {
              document.getElementById("errorReqPassengerSection").innerHTML = "";
            }, 5000);
            return false;
          }
        }
      }
      if (offlineBookingPassengerValid == true) {
        this.buttonDisabled = true;
        this.loaderVar = true;

        if (this.offlineBookingCreate.offlineBookingRequestId == 0) {
          this.offlineBookingCreate.sector = "";
          this.offlineBookingCreate.departureDate = this.offlineBookingCreate.flightRoute[0].departureDate;
          if (this.offlineBookingCreate.tripType == 1) {
            this.offlineBookingCreate.sector = this.offlineBookingCreate.flightRoute[0].departureFrom + '/' + this.offlineBookingCreate.flightRoute[0].arrivalTo + '(OW)';
          }
          else if (this.offlineBookingCreate.tripType == 2) {
            let obj = new FlightRoute();
            obj.arrivalTo = this.offlineBookingCreate.flightRoute[0].departureFrom;
            obj.departureFrom = this.offlineBookingCreate.flightRoute[0].arrivalTo;
            obj.departureDate = this.offlineBookingCreate.returnDate;
            this.offlineBookingCreate.flightRoute.push(obj);
            this.offlineBookingCreate.sector = this.offlineBookingCreate.flightRoute[0].departureFrom + '/' + this.offlineBookingCreate.flightRoute[0].arrivalTo + '(RT)';
          }
          else {

            for (let i: number = 0; i < this.offlineBookingCreate.flightRoute.length; i++) {
              if (i != this.offlineBookingCreate.flightRoute.length - 1) {
                if (i == 0) {
                  this.offlineBookingCreate.sector += this.offlineBookingCreate.flightRoute[i].departureFrom + '/' + this.offlineBookingCreate.flightRoute[i].arrivalTo + '/';
                }
                else if (this.offlineBookingCreate.flightRoute[i].departureFrom != this.offlineBookingCreate.flightRoute[i - 1].arrivalTo) {
                  this.offlineBookingCreate.sector += this.offlineBookingCreate.flightRoute[i].departureFrom + '/' + this.offlineBookingCreate.flightRoute[i].arrivalTo + '/';
                }
                else {
                  this.offlineBookingCreate.sector += this.offlineBookingCreate.flightRoute[i].arrivalTo + '/';
                }
              }
              else {
                if (this.offlineBookingCreate.flightRoute[i].departureFrom != this.offlineBookingCreate.flightRoute[i - 1].arrivalTo) {
                  this.offlineBookingCreate.sector += this.offlineBookingCreate.flightRoute[i].departureFrom + '/' + this.offlineBookingCreate.flightRoute[i].arrivalTo + '(Multi)';
                }
                else {
                  this.offlineBookingCreate.sector += this.offlineBookingCreate.flightRoute[i].arrivalTo + '(Multi)';
                }
              }
            }
          }
          this.offlineBookingCreate.requestStatus = 1;
          this.offlineBookingCreate.offlineRequestTypeId = 2;
          this.offlineBookingCreate.creationUser = Number(localStorage.getItem("UserId"));
          this.offlineBookingCreate.agencyBranchId = localStorage.getItem("AgencyId");
          this.offlineBookingCreate.parentHierarchy = localStorage.getItem("ParentHierarchy");
          const formData = new FormData();
          formData.append('offlineBookingCreate', JSON.stringify(this.offlineBookingCreate));
          formData.append('offlineBookingRequestPassengers', JSON.stringify(this.offlineBookingRequestPassengers));
          this.offlineBookingRequestPassengers.forEach((data, index) => {
            data.files.forEach((file) => {
              formData.append(index.toString(), file, file.name);
            });
          });
          this.requestService.OfflineBookingRequestCreate(formData).subscribe((response) => {
            this.buttonDisabled = false;
            this.loaderVar = false;
            if (response == true) {
              this.router.navigateByUrl('/offlineRequestList');
            }
            else {
              if (this.offlineBookingCreate.tripType == 2) {
                let obj = this.offlineBookingCreate.flightRoute[0];
                this.offlineBookingCreate.flightRoute = [];
                this.offlineBookingCreate.flightRoute.push(obj);
              }
              document.getElementById("errorReqPassengerSection").innerHTML = "**Something Went Wrong!";
              document.getElementById("errorReqPassengerSection").style.color = "#f44336";
              setTimeout(() => {
                document.getElementById("errorReqPassengerSection").innerHTML = "";
                document.getElementById("errorReqPassengerSection").style.color = "";
              }, 5000);
            }
          }, (error) => {
            this.loaderVar = false;
            setTimeout(() => {
              this.buttonDisabled = false;
            }, 500);
            document.getElementById("errorReqPassengerSection").innerHTML = error;
            document.getElementById("errorReqPassengerSection").style.color = "#f44336";
            setTimeout(() => {
              document.getElementById("errorReqPassengerSection").innerHTML = "";
              document.getElementById("errorReqPassengerSection").style.color = "";
            }, 5000);

          });
        }
        else {
          if (this.offlineBookingCreate.offlineBookingRequestId > 0) {
            this.offlineBookingCreate.passengerFares = JSON.stringify(this.offlineBookingRequestFares.passengerFares);
            this.offlineBookingRequestPassengers = this.offlineBookingRequestPassengers.map(pax => {
              return { ...pax, agencyCurrency: localStorage.getItem("AgencyCurrency"), exchangeCurrencyRate: this.offlineBookingCreate.exchangeCurrencyRate }
            });
            this.offlineBookingRequestObject.offlineBookingRequest = this.offlineBookingCreate;
            this.offlineBookingRequestObject.offlineBookingPassengers = this.offlineBookingRequestPassengers;

            this.requestService.OfflineBookingRequestPassengerUpdate(this.offlineBookingRequestObject).subscribe((response) => {
              if (response == true) {
                this.buttonDisabled = false;
                this.loaderVar = false;
                this.OfflineBookingRequestDataGet();
              }
              else {
                this.buttonDisabled = false;
                this.loaderVar = false;
                document.getElementById("errorOfflineBookingCreate").innerHTML = "**Something Went Wrong!";
                document.getElementById("errorOfflineBookingCreate").style.color = "#f44336";
                setTimeout(() => {
                  document.getElementById("errorOfflineBookingCreate").innerHTML = "";
                  document.getElementById("errorOfflineBookingCreate").style.color = "";
                }, 5000);
              }
            }, (error) => {
              this.loaderVar = false;
              setTimeout(() => {
                this.buttonDisabled = false;
              }, 500);
              document.getElementById("errorOfflineBookingCreate").innerHTML = error;
              document.getElementById("errorOfflineBookingCreate").style.color = "#f44336";
              setTimeout(() => {
                document.getElementById("errorOfflineBookingCreate").innerHTML = "";
                document.getElementById("errorOfflineBookingCreate").style.color = "";
              }, 5000);

            });
          }
        }





      }

    }

  }
  public OnDragOver(event: any): void {
    event.preventDefault();
  }
   chatFiles: FileList = undefined;
  public OnFileChange = (event: any, eventTrigger: string): void => {
    event.preventDefault();
    if (event.target.files.length == 0) {
      this.attachedFileName = [];
      this.chatForm.fileAttached = [];
    }
    else {
      
      if (eventTrigger == "click") {
        this.chatFiles = event.target.files;
        for (let f: number = 0; f < this.chatFiles.length; f++) {
          this.chatForm.fileAttached.push(this.chatFiles[f]);
        }
      }
      if (eventTrigger == "drag") {
        this.chatFiles = event.dataTransfer.files;
        for (let f: number = 0; f < this.chatFiles.length; f++) {
          this.chatForm.fileAttached.push(this.chatFiles[f]);
        }
      }
    }
    for (let n = 0; n < this.chatForm.fileAttached.length; n++) {
      this.attachedFileName.push(this.chatForm.fileAttached[n].name);
    }
  }
  public OnClearChatSelection = (index: number): void => {
    this.chatForm.fileAttached.splice(index, 1);
    this.attachedFileName.splice(index, 1);
  }
  public ChatRequest = (chatFormData: any): void => {
    //if (chatFormData.invalid) {
      //return false;
    //}
    //else {
        this.chatButtonDisabeld = true;
    this.newChatForm = new FormData();
    if (this.chatForm.message == undefined || this.chatForm.message.trim() == "") {
      this.chatForm.message = "**no content**";
      }
        this.chatForm.message = this.chatForm.message.trim();
        this.newChatForm.append("message", this.chatForm.message);
        for (let fa = 0; fa < this.chatForm.fileAttached.length; fa++) {
          this.newChatForm.append("fileAttached" + fa, this.chatForm.fileAttached[fa], this.chatForm.fileAttached[fa].name);
        }
        this.newChatForm.append("offlineRequestBookingId", this.offlineBookingCreate.offlineBookingRequestId.toString());
        const timestamp = Date.now();
        const chatTime = new Date(timestamp);
        const formatedChatTime = `${chatTime.getHours().toString().padStart(2, '0')}:${chatTime.getMinutes().toString().padStart(2, '0')} ${chatTime.getDate().toString().padStart(2, '0')}-${(chatTime.getMonth() + 1).toString().padStart(2, '0')}-${chatTime.getFullYear()}`;
        this.newChatForm.append("chatTime", formatedChatTime);
        if (Number(localStorage.getItem("UserId")) == this.offlineBookingCreate.creationUser) {
          this.newChatForm.append("userId", this.offlineBookingCreate.creationUser.toString());
          this.newChatForm.append("managerId", this.offlineBookingCreate.agencyBranchManagerId.toString());
          this.chatForm.isManager = false;
          this.newChatForm.append("isManager", this.chatForm.isManager.toString());
        }
        else if (Number(localStorage.getItem("UserId")) == this.offlineBookingCreate.agencyBranchManagerId) {
          this.newChatForm.append("userId", this.offlineBookingCreate.creationUser.toString());
          this.newChatForm.append("managerId", this.offlineBookingCreate.agencyBranchManagerId.toString());
          this.chatForm.isManager = true;
          this.newChatForm.append("isManager", this.chatForm.isManager.toString());

        }
        this.requestService.ChatMessagesCommunication(this.newChatForm).subscribe(data => {
          this.chatForm = new ChatForm();
          this.attachedFileName = [];
          this.chatMessages = data;
          this.chatButtonDisabeld = false;
          if (this.chatMessages.length > 0) {
            this.ScrollerChat();
          }

        })
      
    //}
  }
  ngAfterViewInit(): void {
    this.ScrollerChat();
  }
  private ScrollerChat = (): void => {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {
    }

  }
  public RequestFileDownload = (filePath: string): void => {
    let fileTypeArray: string[] = filePath.split('.');
    let fileType: string = fileTypeArray[fileTypeArray.length - 1];
    if (fileType.includes('pdf')) {
      fileType = 'application/pdf';
    } else {
      fileType = 'image/' + fileType;
    }
    this.requestService.OfflineBookingRequestFileDownload(filePath, fileType).subscribe(
      (data: Blob) => {
        importedSaveAs(data, filePath.split('.')[filePath.split('.').length - 2] + "." + fileType.split('/')[1]);
      }
    )
  }
  public OpenAcceptOfferModel = (): void => {
    this.bookingMessageStatusUpdate = new OfflineBookingMessageStatusUpdate();
    this.bookingMessageStatusUpdate.messageId = 0;
    this.bookingMessageStatusUpdate.messageStatus = 0;
    this.bookingMessageStatusUpdate.offlineBookingRequestId = this.offlineBookingCreate.offlineBookingRequestId;
    this.bookingMessageStatusUpdate.offlineBookingRequestStatus = 4;
    this.primeShowModalApproveModel = true;

  }
  public CloseApproveOfferModel = (): void => {
    this.bookingMessageStatusUpdate = new OfflineBookingMessageStatusUpdate();
    this.primeShowModalApproveModel = false;
  }
  public ApproveOfferConfirm = (): void => {
    this.loaderConfimVar = true;
    this.requestService.AcceptOfferConfirm(this.bookingMessageStatusUpdate).subscribe(data => {
      this.offlineBookingCreate = data.offlineBookingRequest;
      if (this.offlineBookingCreate.tripType == 2) {
        this.offlineBookingCreate.returnDate = this.offlineBookingCreate.flightRoute[1].departureDate;
        this.offlineBookingCreate.flightRoute.splice(1, 1);
        this.hideReturnDate = true;
      }
      this.chatMessages = data.chatMessages;
      this.showBookingRequestBasicInfoSection = true;
      this.showBookingRequestPassengerSection = false;
      this.loaderConfimVar = false;
      this.CloseApproveOfferModel();
    });

  }
  private GetBookingBaseData = (): void => {
    try {
      this.ticketService.GetTicketBaseData().subscribe((data) => {
        this.ticketSupplierList = data.ticketSuppliersProperties;
      });

    }
    catch (e) {
      console.log(e)
    }
  }
  public GetSupplierAccessCodes = (supplierId: string): void => {
    try {
      this.requestService.GetOffliBookingRequestSupplierAccessCode(supplierId).subscribe(data => {
        this.ticketSupplierAccessCodeList = data;
        this.accessCodeDisabled = false;
      });
    }
    catch (ex) {
      console.log(ex);
    }
  }
  public OnChangeSupplierAccessCodes = (bookingPcc: string): void => {
    const filterCurrency = this.ticketSupplierAccessCodeList.find(x => x.officeId == bookingPcc);
    if (filterCurrency) {
      const supplierCurrency = this.suppliersCurrencyList.find(x => x.supplierCurrencyId == filterCurrency.currencyId);
      if (supplierCurrency) {
        this.offlineBookingRequestPassengers = this.offlineBookingRequestPassengers.map(pas => {
          return { ...pas, supplierCurrencyId: filterCurrency.currencyId, supplierCurrency: supplierCurrency.supplierCurrencyName }
        });
      }

    }
  }
  public SendBookingProposal = (): void => {
    this.OfflineBookingRequestGet(this.offlineBookingParam);
    this.showofflineBookingProposalSection = true;
    this.bookingProperties.journeyTypeId = this.offlineBookingCreate.tripType;
    this.bookingProperties.bookingPcc = this.offlineBookingCreate.bookingPcc;
    this.bookingProperties.bookingSource = this.offlineBookingCreate.bookingSource;
    this.bookingProperties.supplierCurrency = this.offlineBookingRequestPassengers[0].supplierCurrency;
    this.showofflineBookingBasicInformationSection = true;
    if (this.bookingProperties.offlineBookingId == 0) {
      if (this.bookingProperties.journeyTypeId == 1) {
        let onewayTrip = new OfflineBookingTripDetails();
        onewayTrip.departureSegment = true;
        onewayTrip.segmentType = 1;
        this.offlineBookingOnewayTrip.push(onewayTrip);
      }
      else if (this.bookingProperties.journeyTypeId == 2) {
        let onewayTrip = new OfflineBookingTripDetails();
        onewayTrip.departureSegment = true;
        onewayTrip.segmentType = 2;
        this.offlineBookingOnewayTrip.push(onewayTrip);
        let returnTrip = new OfflineBookingTripDetails();
        returnTrip.returnSegment = true;
        returnTrip.segmentType = 2;
        this.offlineBookingReturnTrip.push(returnTrip);
      }
      else if (this.bookingProperties.journeyTypeId == 3) {
        for (let i: number = 0; i < this.offlineBookingCreate.flightRoute.length; i++) {
          this.offlineBookingMulticityTrip[i] = [];
          let multiTrip = new OfflineBookingTripDetails();
          multiTrip.multicitySegment = true;
          multiTrip.segmentType = 3;
          this.offlineBookingMulticityTrip[i]
          this.offlineBookingMulticityTrip[i].push(multiTrip);

        }
      }
    }
    this.primeShowModalProposal = true;

  }
  public CheckDetailsApprovelProposal = (): void => {
    this.showofflineBookingProposalSection = true;
    this.showofflineBookingBasicInformationSection = true;
    this.primeShowModalProposal = true;
  }
  public OpenCompleteDetail = (): void => {
    this.OfflineBookingRequestGet(this.offlineBookingParam);
    this.showofflineBookingProposalSection = true;
    this.showofflineBookingBasicInformationSection = true;
    this.primeShowModalProposal = true;
    this.showSavePassengerButton = true;
  }
  public SendApproveBookingStatus = (): void => {
    this.bookingMessageStatusUpdate = new OfflineBookingMessageStatusUpdate();
    this.bookingMessageStatusUpdate.messageId = 0;
    this.bookingMessageStatusUpdate.messageStatus = 0;
    this.bookingMessageStatusUpdate.offlineBookingRequestId = this.offlineBookingCreate.offlineBookingRequestId;
    this.bookingMessageStatusUpdate.offlineBookingRequestStatus = 6;
    this.primeShowModalApproveModel = true;
  }
  public IssueTicketOfflineBooking = (): void => {
    this.OfflineBookingRequestGet(this.offlineBookingParam);
    this.showSavePassengerButton = false;
    this.primeShowModalProposal = true;
    this.showofflineBookingProposalSection = true;
    this.showPassengerDetailsSection = true;
    this.showTicketNumberField = true;
  }
  public SubmitBookingDetailsBasics = (basicDetailsForm: any): boolean => {
    this.offlineBookingBasicInformationSubmited = true;
    let bookingSubmittedValid: boolean = true;
    if (basicDetailsForm.invalid) {
      return false;
    }
    else {
      if (this.bookingProperties.fareRulesDetails.trim() == "") {
        bookingSubmittedValid = false;
        return false;
      }
      else {
        this.bookingProperties.fareRulesDetails = this.bookingProperties.fareRulesDetails.trim();
      }
      if (this.bookingProperties.generalRules.trim() == "") {
        bookingSubmittedValid = false;
        return false;
      }
      else {
        this.bookingProperties.generalRules = this.bookingProperties.generalRules.trim();
      }
      if (this.bookingProperties.remarks.trim() == "") {
        bookingSubmittedValid = false;
        return false;
      }
      else {
        this.bookingProperties.remarks = this.bookingProperties.remarks.trim();
      }

      if (bookingSubmittedValid == true) {
        this.showSegmentDetailsSection = true;
        if (this.bookingProperties.journeyTypeId == 1) {
          this.oneWayBookingSegmentSection = true;
        }
        else if (this.bookingProperties.journeyTypeId == 2) {
          this.oneWayBookingSegmentSection = true;
          this.returnBookingSegmentSection = true;
        }
        else if (this.bookingProperties.journeyTypeId == 3) {
          this.multicityBookingSegmentSection = true;
        }
        this.showofflineBookingBasicInformationSection = false;
      }
    }

  }
  public AddNewOnewaySegment = (): void => {
    let onewayTrip = new OfflineBookingTripDetails();
    onewayTrip.departureSegment = true;
    onewayTrip.segmentType = 1;
    this.offlineBookingOnewayTrip.push(onewayTrip);
  }
  public AddNewDepartueReturnSegment = (): void => {
    let onewayTrip = new OfflineBookingTripDetails();
    onewayTrip.departureSegment = true;
    onewayTrip.segmentType = 2;
    this.offlineBookingOnewayTrip.push(onewayTrip);
  }
  public AddNewMultiSegment = (index: number): void => {
    let multiTrip = new OfflineBookingTripDetails();
    multiTrip.multicitySegment = true;
    multiTrip.segmentType = 3;
    this.offlineBookingMulticityTrip[index].push(multiTrip);
  }
  public AddNewReturnSegment = (): void => {
    let returnTrip = new OfflineBookingTripDetails();
    returnTrip.returnSegment = true;
    returnTrip.segmentType = 2;
    this.offlineBookingReturnTrip.push(returnTrip);
  }
  public RemoveOnewaySegment = (index: number): void => {
    if (this.offlineBookingOnewayTrip.length > 1) {
      this.offlineBookingOnewayTrip[index].segmentType = 0;
      this.offlineBookingOnewayTrip[index].departureSegment = false;
      this.offlineBookingOnewayTrip.splice(index, 1);
    }
    else {
      document.getElementById(`InformationTitle${0}`).innerHTML = "Not Allowed to Remove All Segment!";
      document.getElementById(`InformationTitle${0}`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`InformationTitle${0}`).innerHTML = "Segment Information: <b>1</b>";
        document.getElementById(`InformationTitle${0}`).style.color = "";
      }, 4000)
    }
  }
  public RemoveReturnSegment = (index: number): void => {
    if (this.offlineBookingReturnTrip.length > 1) {
      this.offlineBookingReturnTrip[index].segmentType = 0;
      this.offlineBookingReturnTrip[index].departureSegment = false;
      this.offlineBookingReturnTrip.splice(index, 1);
    }
    else {
      document.getElementById(`InformationTitleReturn${0}`).innerHTML = "Not Allowed to Remove All Segment!";
      document.getElementById(`InformationTitleReturn${0}`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`InformationTitleReturn${0}`).innerHTML = "Segment Information: <b>1</b>";
        document.getElementById(`InformationTitleReturn${0}`).style.color = "";
      }, 4000)
    }
  }
  public RemoveMultiSegment = (indexOut: number, indexIn: number): void => {
    if (this.offlineBookingMulticityTrip[indexOut].length > 1) {
      this.offlineBookingMulticityTrip[indexOut][indexIn].segmentType = 0;
      this.offlineBookingMulticityTrip[indexOut][indexIn].departureSegment = false;
      this.offlineBookingMulticityTrip[indexOut].splice(indexIn, 1);
    }
    else {
      document.getElementById(`InformationTitleMulti${indexOut}${0}`).innerHTML = "Not Allowed to Remove All Segment!";
      document.getElementById(`InformationTitleMulti${indexOut}${0}`).style.color = "red";
      setTimeout(() => {
        document.getElementById(`InformationTitleMulti${indexOut}${0}`).innerHTML = "Segment Information: <b>1</b>";
        document.getElementById(`InformationTitleMulti${indexOut}${0}`).style.color = "";
      }, 4000)
    }
  }
  public OneWaySegmentDepartureFrom = (fromAirport: string, index: number): void => {
    this.offlineBookingOnewayTrip[index].fromAirport = fromAirport.split("-")[0].trim();
  }
  public ReturnSegmentDepartureFrom = (fromAirport: string, index: number): void => {
    this.offlineBookingReturnTrip[index].fromAirport = fromAirport.split("-")[0].trim();
  }
  public MultiSegmentDepartureFrom = (fromAirport: string, indexOut: number, indexIn: number): void => {
    this.offlineBookingMulticityTrip[indexOut][indexIn].fromAirport = fromAirport.split("-")[0].trim();
  }
  public OneWaySegmentArrivalTo = (toAirport: string, index: number): void => {
    this.offlineBookingOnewayTrip[index].toAirport = toAirport.split("-")[0].trim();
  }
  public ReturnSegmentArrivalTo = (toAirport: string, index: number): void => {
    this.offlineBookingReturnTrip[index].toAirport = toAirport.split("-")[0].trim();
  }
  public MultiSegmentArrivalTo = (toAirport: string, indexOut: number, indexIn: number): void => {
    this.offlineBookingMulticityTrip[indexOut][indexIn].toAirport = toAirport.split("-")[0].trim();
  }
  public OneWaySegmentDateValidationDeparture = (date: any, index: number): void => {
    if (date.target.value == "") {
      this.offlineBookingOnewayTrip[index].travellingDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingOnewayTrip[index].travellingDate = this.currentDate;
    }
    else {
      this.offlineBookingOnewayTrip[index].travellingDate = date.target.value;
    }
  }
  public ReturnSegmentDateValidationDeparture = (date: any, index: number): void => {
    if (date.target.value == "") {
      this.offlineBookingReturnTrip[index].travellingDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingReturnTrip[index].travellingDate = this.currentDate;
    }
    else {
      this.offlineBookingReturnTrip[index].travellingDate = date.target.value;
    }
  }
  public MultiSegmentDateValidationDeparture = (date: any, indexOut: number, indexIn: number): void => {
    if (date.target.value == "") {
      this.offlineBookingMulticityTrip[indexOut][indexIn].travellingDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingMulticityTrip[indexOut][indexIn].travellingDate = this.currentDate;
    }
    else {
      this.offlineBookingMulticityTrip[indexOut][indexIn].travellingDate = date.target.value;
    }
  }
  public OneWaySegmentDateValidationArival = (date: any, index: number): void => {
    if (date.target.value == "") {
      this.offlineBookingOnewayTrip[index].arrivalDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingOnewayTrip[index].arrivalDate = this.currentDate;
    }
    else {
      this.offlineBookingOnewayTrip[index].arrivalDate = date.target.value;
    }
  }
  public ReturnSegmentDateValidationArival = (date: any, index: number): void => {
    if (date.target.value == "") {
      this.offlineBookingReturnTrip[index].arrivalDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingReturnTrip[index].arrivalDate = this.currentDate;
    }
    else {
      this.offlineBookingReturnTrip[index].arrivalDate = date.target.value;
    }
  }
  public MultiSegmentDateValidationArival = (date: any, indexOut: number, indexIn: number): void => {
    if (date.target.value == "") {
      this.offlineBookingMulticityTrip[indexOut][indexIn].arrivalDate = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingMulticityTrip[indexOut][indexIn].arrivalDate = this.currentDate;
    }
    else {
      this.offlineBookingMulticityTrip[indexOut][indexIn].arrivalDate = date.target.value;
    }
  }
  public SubmitSegment = (segmentForm: any): boolean => {
    this.offlineBookingSegmentSubmitted = true;
    let validateSegments: boolean = true;
    if (segmentForm.invalid) {
      document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Required Filelds!";
      setTimeout(() => {
        document.getElementById("errorSegmentSection").innerHTML = "";
      }, 5000);
      return false;
    }
    else {
      if (this.returnBookingSegmentSection == true) {
        if (this.offlineBookingReturnTrip[0].fromAirport != this.offlineBookingOnewayTrip[this.offlineBookingOnewayTrip.length - 1].toAirport) {
          validateSegments = false;
          document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Valid Segments!";
          setTimeout(() => {
            document.getElementById("errorSegmentSection").innerHTML = "";
          }, 5000);
          return false;
        }
        if (this.offlineBookingReturnTrip[this.offlineBookingReturnTrip.length - 1].toAirport != this.offlineBookingOnewayTrip[0].fromAirport) {
          validateSegments = false;
          document.getElementById("errorSegmentSection").innerHTML = "**Please Enter Valid Segments!";
          setTimeout(() => {
            document.getElementById("errorSegmentSection").innerHTML = "";
          }, 5000);
          return false;
        }
      }
      if (validateSegments == true) {
        if (this.bookingProperties.offlineBookingId == 0) {
          this.offlineBookingPassengerDetails = this.offlineBookingRequestPassengers;
          this.grandTotal = this.requestGrandTotal;
        }
        this.showPassengerDetailsSection = true;
        this.showSegmentDetailsSection = false;
      }

    }
  }
  public SetBackTicketStart = (): void => {
    this.showofflineBookingBasicInformationSection = true;
    this.showSegmentDetailsSection = false;
  }
  public PassengerDateDateValidationDOB = (date: any, index: number): void => {

    if (date.target.value == "") {
      this.offlineBookingRequestPassengers[index].paxDOB = undefined;
    }
    else if (new Date(date.target.value) > new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingRequestPassengers[index].paxDOB = this.currentDate;
    }
    else {
      this.offlineBookingRequestPassengers[index].paxDOB = date.target.value;
    }
  }
  public PassengerDateDateValidationPassport = (date: any, index: number): void => {
    if (date.target.value == "") {
      this.offlineBookingRequestPassengers[index].passportValidTo = undefined;
    }
    else if (new Date(date.target.value) < new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.offlineBookingRequestPassengers[index].passportValidTo = this.currentDate;
    }
    else {
      this.offlineBookingRequestPassengers[index].passportValidTo = date.target.value;
    }
  }
  public CalculateTotalAmount = (index: number): void => {
    if (this.offlineBookingPassengerDetails[index].serviceCharges < 0 || this.offlineBookingPassengerDetails[index].serviceCharges == null) {
      this.offlineBookingPassengerDetails[index].serviceCharges = 0
    }
    if (this.offlineBookingPassengerDetails[index].discount < 0 || this.offlineBookingPassengerDetails[index].discount == null) {
      this.offlineBookingPassengerDetails[index].discount = 0
    }
    this.offlineBookingPassengerDetails[index].netTotalAmount
      = (this.offlineBookingPassengerDetails[index].fareValue + this.offlineBookingPassengerDetails[index].tax + this.offlineBookingPassengerDetails[index].serviceCharges
        - this.offlineBookingPassengerDetails[index].discount);

    this.grandTotal = 0;
    for (let i: number = 0; i < this.offlineBookingPassengerDetails.length; i++) {
      this.grandTotal += this.offlineBookingPassengerDetails[i].netTotalAmount;
    }

  }
  public SubmitOfflineBookingPassengerDetails = (passengerForm: any): boolean => {
    this.offlineBookingPassengerSubmitted = true;
    let offlineBookingPassengerValid: boolean = true;
    if (passengerForm.invalid) {
      document.getElementById("errorPassengerSection").innerHTML = "**Please Enter Required Filelds!";
      setTimeout(() => {
        document.getElementById("errorPassengerSection").innerHTML = "";
      }, 5000);
      return false;
    }
    else {

      for (let i: number = 0; i < this.offlineBookingPassengerDetails.length; i++) {
        if (this.bookingProperties.offlineBookingId > 0) {
          if (this.MobileNumberValidateWhenSearch(this.offlineBookingPassengerDetails[i].mobile) == false) {
            offlineBookingPassengerValid = false;
            document.getElementById(`passengerInfoErrorMobileNumbers${i}`).innerText = "**Invalid Number Pattern!";
            setTimeout(() => {
              document.getElementById(`passengerInfoErrorMobileNumbers${i}`).innerText = "";
            }, 3000);
            return false;
          }
          if ((this.offlineBookingPassengerDetails[i].ticketNo.trim() == "") && this.offlineBookingCreate.requestStatus == 6) {
            offlineBookingPassengerValid = false;
            document.getElementById("errorPassengerSection").innerHTML = "**Please Enter Ticket Number!";
            setTimeout(() => {
              document.getElementById("errorPassengerSection").innerHTML = "";
            }, 5000);
            return false;
          }
        }
        if (this.offlineBookingPassengerDetails[i].fareValue <= 0) {
          offlineBookingPassengerValid = false;
          document.getElementById("errorPassengerSection").innerHTML = "**Values Should Be Grater Than '0'!";
          setTimeout(() => {
            document.getElementById("errorPassengerSection").innerHTML = "";
          }, 5000);
          return false;
        }
        if (this.offlineBookingPassengerDetails[i].tax <= 0) {
          offlineBookingPassengerValid = false;
          document.getElementById("errorPassengerSection").innerHTML = "**Values Should Be Grater Than '0'!";
          setTimeout(() => {
            document.getElementById("errorPassengerSection").innerHTML = "";
          }, 5000);
          return false;
        }

      }
      if (this.offlineBookingCreate.requestStatus == 6) {
        for (let i: number = 1; i < this.offlineBookingPassengerDetails.length; i++) {
          if (this.offlineBookingPassengerDetails[i].ticketNo == this.offlineBookingPassengerDetails[i - 1].ticketNo) {
            offlineBookingPassengerValid = false;
            return false;
          }
        }
      }
      if (offlineBookingPassengerValid == true) {
        this.offlineBookingWrapper.booking = this.bookingProperties;
        this.offlineBookingWrapper.booking.agencyBranchId = this.offlineBookingCreate.agencyBranchId;
        this.offlineBookingWrapper.booking.creationUser = this.offlineBookingCreate.creationUser;
        this.offlineBookingWrapper.booking.parentHierarchy = this.offlineBookingCreate.parentHierarchy;
        this.offlineBookingWrapper.booking.offlineBookingRequestId = this.offlineBookingCreate.offlineBookingRequestId;
        this.offlineBookingWrapper.booking.issuingAirline = this.offlineBookingCreate.airlineName;
        this.offlineBookingWrapper.booking.travelDate = String(this.offlineBookingCreate.flightRoute[0].departureDate);
        this.offlineBookingWrapper.booking.requestTypeId = 2;
        this.offlineBookingWrapper.booking.status = 0;
        this.offlineBookingWrapper.passengerList = this.offlineBookingPassengerDetails;
        let agencyCurrencyGet: string = localStorage.getItem("AgencyCurrency");
        this.offlineBookingWrapper.passengerList = this.offlineBookingWrapper.passengerList.map(pax => {
          return {
            ...pax, bookingPcc: this.offlineBookingWrapper.booking.bookingPcc, supplierCode: this.offlineBookingWrapper.booking.bookingSource, issuancePcc: "",
            creationUser: this.offlineBookingWrapper.booking.creationUser, agencyCurrency: agencyCurrencyGet, netToSupplier: pax.fareValue + pax.tax,
            netFromCustomer: (pax.fareValue + pax.tax + pax.serviceCharges) - pax.discount,
          }
        });
        this.offlineBookingWrapper.tripList = [];
        if (this.offlineBookingOnewayTrip.length > 0 && this.offlineBookingOnewayTrip != null) {
          for (let d: number = 0; d < this.offlineBookingOnewayTrip.length; d++) {
            this.offlineBookingWrapper.tripList.push(this.offlineBookingOnewayTrip[d]);
          }
        }
        if (this.offlineBookingReturnTrip.length > 0 && this.offlineBookingReturnTrip != null) {
          for (let r: number = 0; r < this.offlineBookingReturnTrip.length; r++) {
            this.offlineBookingWrapper.tripList.push(this.offlineBookingReturnTrip[r]);
          }
        }
        if (this.offlineBookingMulticityTrip.length > 0 && this.offlineBookingMulticityTrip != null) {
          for (let m: number = 0; m < this.offlineBookingMulticityTrip.length; m++) {
            for (let mc: number = 0; mc < this.offlineBookingMulticityTrip[m].length; mc++) {
              this.offlineBookingWrapper.tripList.push(this.offlineBookingMulticityTrip[m][mc]);
            }
          }
        }
        this.loaderSaveVar = true;
        this.buttonSaveDisabled = true;
        if (this.bookingProperties.offlineBookingId == 0 && this.offlineBookingCreate.requestStatus != 6) {
          this.offlineService.saveOfflineTktRequest(this.offlineBookingWrapper).subscribe((data) => {
            if (data == true) {
              this.loaderSaveVar = false;
              this.buttonSaveDisabled = false;
              this.OfflineBookingRequestDataGet();
            }
            else {
              this.loaderSaveVar = false;
              this.buttonSaveDisabled = false;
              document.getElementById("errorPassengerSection").innerText = "**Something Went Wrong!";
              setTimeout(() => {
                document.getElementById("errorPassengerSection").innerText = "";
              }, 4000)

            }

          });
        }
        else {
          if (this.offlineBookingCreate.requestStatus == 6) {
            this.offlineBookingWrapper.passengerFares = JSON.parse(this.offlineBookingCreate.passengerFares);
            // console.log(this.offlineBookingWrapper.passengerFares);
            this.offlineBookingWrapper.booking.approvalRejectionUser = Number(localStorage.getItem("UserId"));
            this.requestService.IssueTicketOffilneBooking(this.offlineBookingWrapper).subscribe((data) => {
              if (data.isSaved == true) {
                this.loaderSaveVar = false;
                this.buttonSaveDisabled = false;
                this.OfflineBookingRequestDataGet();
              }
              else {
                this.loaderSaveVar = false;
                this.buttonSaveDisabled = false;
                document.getElementById("errorPassengerSection").innerText = data.errorInfo;
                setTimeout(() => {
                  document.getElementById("errorPassengerSection").innerText = "";
                }, 4000)

              }
            });
          }
        }
      }
    }

  }
  private OfflineBookingRequestDataGet = (): void => {
    this.offlineBookingParam.statusOpen = false;
    this.offlineBookingParam.managerId = 0;
    this.OfflineBookingRequestGet(this.offlineBookingParam);
    this.CloseBookingProposalSection();
  }
  public SetBackToSegment = (): void => {
    this.showPassengerDetailsSection = false;
    this.showSegmentDetailsSection = true;
  }
  public CloseBookingProposalSection = (): void => {
    if (this.bookingProperties.offlineBookingId == 0) {
      this.offlineBookingWrapper = new OfflineBookingWrapper();
      this.bookingProperties = new OfflineBookingProperties();
      this.offlineBookingOnewayTrip = [];
      this.offlineBookingReturnTrip = [];
      this.offlineBookingMulticityTrip = [];
      this.offlineBookingPassengerDetails = [];
    }
    this.offlineBookingBasicInformationSubmited = false;
    this.showofflineBookingProposalSection = false;
    this.showofflineBookingBasicInformationSection = false;
    this.showSegmentDetailsSection = false;
    this.oneWayBookingSegmentSection = false;
    this.returnBookingSegmentSection = false;
    this.multicityBookingSegmentSection = false;
    this.offlineBookingSegmentSubmitted = false;
    this.showPassengerDetailsSection = false;
    this.offlineBookingPassengerSubmitted = false;
    this.primeShowModalProposal = false;
    this.showTicketNumberField = false;
  }
  public MobileNumberValidateWhenSearch = (mobile: string): boolean => {
    var pattern = /^\+\d{3}?\d+$/;
    if (mobile.match(pattern)) {
      return true;
    }
    else {
      return false;
    }
  }
  public GetPassengerInformation = (mobile: string, index: number): boolean => {
    if (mobile != "" && mobile != undefined && mobile != null) {
      if (this.MobileNumberValidateWhenSearch(mobile) == false) {
        document.getElementById(`reqPassengerInfoErrorMobileNumbers${index}`).innerText = "**Invalid Number Pattern!";
        setTimeout(() => {
          document.getElementById(`reqPassengerInfoErrorMobileNumbers${index}`).innerText = "";
        }, 3000);
        return false;
      }
      else {
        try {
          let contactnumber: object = {
            ctcno: mobile,
          };
          this.userService.GetPassengerProfileSearch(contactnumber).subscribe((data) => {
            this.searchprofileCred = data;
            for (let j = 0; j < this.searchprofileCred.length; j++) {
              this.searchprofileCred[j].passengerindex = index;
            }
            if (this.searchprofileCred.length > 0) {
              this.primeShowModalPaxInfo = true;
            }
          });
        }
        catch (e) {
          console.log(e);
        }
      }
    }

  }
  public CloseBookingPassengerInfoSection = (): void => {
    this.primeShowModalPaxInfo = false;
  }
  public SelectPassengerProfileData = (data: any): void => {
    let index = data.passengerindex;

    for (let i = 0; i < this.offlineBookingRequestPassengers.length; i++) {
      if (index == i) {
        this.offlineBookingRequestPassengers[i].profile_Id = data.profile_Id;
        if (this.offlineBookingRequestPassengers[i].passengerTypeId == 1) {
          this.offlineBookingRequestPassengers[i].title = this.passengerTitleList[0].passengerTitleName;
        }
        else if (this.offlineBookingRequestPassengers[i].passengerTypeId == 2) {
          this.offlineBookingRequestPassengers[i].title = this.passengerTitleList[1].passengerTitleName;
        }
        else if (this.offlineBookingRequestPassengers[i].passengerTypeId == 3) {
          this.offlineBookingRequestPassengers[i].title = this.passengerTitleList[2].passengerTitleName;
        }
        this.offlineBookingRequestPassengers[i].firstName = data.firstName;
        this.offlineBookingRequestPassengers[i].lastName = data.lastName;
        this.offlineBookingRequestPassengers[i].paxGender = data.paxGender;
        this.offlineBookingRequestPassengers[i].paxDOB = data.paxDOB;
        this.offlineBookingRequestPassengers[i].mobile = data.mobile_No;
        this.offlineBookingRequestPassengers[i].nationality = data.paxNationality;
        this.offlineBookingRequestPassengers[i].passportValidTo = data.passportValidTo;
        this.offlineBookingRequestPassengers[i].passportNumber = data.passportNumber;
        this.offlineBookingRequestPassengers[i].countryOfIssuance = data.countryOfIssuance;
        this.offlineBookingRequestPassengers[i].email = data.email_Id;
        this.offlineBookingRequestPassengers[i].frequent_Flyer_No = data.frequent_Flyer_No;
        this.primeShowModalPaxInfo = false;
        break;
      }
    }

  }
  public OpenBookingRejectModel = (): void => {
    this.primeShowModalReject = true;
  }
  public CloseBookingRejectModel = (): void => {
    this.primeShowModalReject = false;
  }
  public RejectionSubmit = (rejectionForm: any): boolean => {
    this.offlineBookingRejectionSubmited = true;
    if (rejectionForm.invalid) {
      return false;
    }
    else {
      if (this.offlineBookingRejection.rejectionMessage.trim() == "") {
        return false;
      }
      else {
        this.loaderConfimVar = true;
        this.offlineBookingRejection.rejectionMessage = this.offlineBookingRejection.rejectionMessage.trim();
        this.offlineBookingRejection.requestStatus = 8;
        this.offlineBookingRejection.offlineBookingRequestId = this.offlineBookingCreate.offlineBookingRequestId;
        this.requestService.OffilneBookingRejectionCall(this.offlineBookingRejection).subscribe((data) => {
          if (data == true) {
            this.CloseBookingRejectModel();
            this.OfflineBookingRequestDataGet();
            this.loaderConfimVar = false;
          }
          else {
            this.loaderConfimVar = false;
            document.getElementById("errorRejectSection").innerText = "**Something Went Wrong!";
            setTimeout(() => {
              document.getElementById("errorRejectSection").innerText = "";
            }, 4000);
          }
        });

      }

    }
  }
  public CalculateRevenue = (): boolean => {
    let sendRequest: boolean = true;
    this.offlineBookingRequestPassengerSubmitted = false;
    if (this.offlineBookingCreate.bookingSource == "") {
      document.getElementById("errsBookingSourceInfoError").innerHTML = "**Supplier Code Required!";
      document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Fields";
      setTimeout(() => {
        document.getElementById("errsBookingSourceInfoError").innerHTML = "";
        document.getElementById("errorReqPassengerSection").innerHTML = "";
      }, 5000);
    }
    if (this.offlineBookingCreate.bookingPcc == "") {
      document.getElementById("errsSupplierCodeInfoError").innerHTML = "**Booking PCC Required!";
      document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Fields";
      setTimeout(() => {
        document.getElementById("errsSupplierCodeInfoError").innerHTML = "";
        document.getElementById("errorReqPassengerSection").innerHTML = "";
      }, 5000);
    }
    if (this.offlineBookingCreate.exchangeCurrencyRate <= 0 || this.offlineBookingCreate.exchangeCurrencyRate == undefined || this.offlineBookingCreate.exchangeCurrencyRate == null) {
      document.getElementById("exchangeCurrencyRateInfoError").innerHTML = "**Invalid Exchange Rate!";
      document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Fields";
      setTimeout(() => {
        document.getElementById("exchangeCurrencyRateInfoError").innerHTML = "";
        document.getElementById("errorReqPassengerSection").innerHTML = "";
      }, 5000);
    }
    if ((this.offlineBookingCreate.bookingSource == "") || (this.offlineBookingCreate.bookingPcc == "")
      || (this.offlineBookingCreate.exchangeCurrencyRate <= 0 || this.offlineBookingCreate.exchangeCurrencyRate == undefined || this.offlineBookingCreate.exchangeCurrencyRate == null)) {
      sendRequest = false;
      return false;
    }

    for (let i: number = 0; i < this.offlineBookingRequestPassengers.length; i++) {
      // if (this.offlineBookingRequestPassengers[i].supplierCurrency == "") {
      //   sendRequest = false;
      //   document.getElementById("errorReqPassengerSection").innerHTML = "**Please Enter Required Fields";
      //   document.getElementById(`reqSupplierCurrencyInfoErrors${i}`).innerHTML = "**Currency Required";
      //   setTimeout(() => {
      //     document.getElementById(`reqSupplierCurrencyInfoErrors${i}`).innerHTML = "";
      //     document.getElementById("errorReqPassengerSection").innerHTML = "";
      //   }, 5000);
      //   return false;
      // }
      if (this.offlineBookingRequestPassengers[i].fareValue <= 0) {
        sendRequest = false;
        document.getElementById("errorReqPassengerSection").innerHTML = "**Should Be Grater Than '0'";
        document.getElementById(`passengerInfoErrorfareValues${i}`).innerHTML = "**Should Be Grater Than '0'";
        setTimeout(() => {
          document.getElementById(`passengerInfoErrorfareValues${i}`).innerHTML = "";
          document.getElementById("errorReqPassengerSection").innerHTML = "";
        }, 5000);
        return false;
      }
      if (this.offlineBookingRequestPassengers[i].tax <= 0) {
        sendRequest = false;
        document.getElementById("errorReqPassengerSection").innerHTML = "**Should Be Grater Than '0'";
        document.getElementById(`passengerInfoErrortaxs${i}`).innerHTML = "**Should Be Grater Than '0'";
        setTimeout(() => {
          document.getElementById(`passengerInfoErrortaxs${i}`).innerHTML = "";
          document.getElementById("errorReqPassengerSection").innerHTML = "";
        }, 5000);
        return false;

      }
    }
    if (sendRequest == true) {

      this.offlineBookingRequestFares.booking = new OfflineBookingProperties();
      this.offlineBookingRequestFares.tripList = [];
      this.offlineBookingRequestFares.passengerList = [];
      this.offlineBookingRequestFares.passengerFares = [];
      this.offlineBookingRequestFares.creditLimit = 0;
      this.offlineBookingRequestFares.pendingCreditLimit = 0;
      this.offlineBookingRequestFares.agencyId = this.offlineBookingCreate.agencyBranchId;
      this.offlineBookingRequestFares.booking.journeyTypeId = this.offlineBookingCreate.tripType;
      this.offlineBookingRequestFares.booking.travelDate = String(this.offlineBookingCreate.departureDate).split('T')[0];
      this.offlineBookingRequestFares.booking.issuingAirline = this.offlineBookingCreate.airlineName;
      this.offlineBookingRequestFares.booking.bookingSource = this.offlineBookingCreate.bookingSource;
      this.offlineBookingRequestFares.booking.bookingPcc = this.offlineBookingCreate.bookingPcc;
      this.offlineBookingRequestFares.passengerList = this.offlineBookingRequestPassengers;
      for (let i: number = 0; i < this.offlineBookingCreate.flightRoute.length; i++) {
        let trip = new OfflineBookingTripDetails();
        trip.fromAirport = this.offlineBookingCreate.flightRoute[i].departureFrom;
        trip.toAirport = this.offlineBookingCreate.flightRoute[i].arrivalTo;
       // trip.flightNo = this.offlineBookingCreate.flightNo;
        trip.flightNumber = this.offlineBookingCreate.flightNo;
        trip.travellingClass = this.offlineBookingCreate.cabinClass;
        trip.rbd = this.offlineBookingCreate.rbd;
        trip.travellingDate = String(this.offlineBookingCreate.flightRoute[i].departureDate).split('T')[0];
        trip.arrivalDate = String(this.offlineBookingCreate.flightRoute[i].departureDate).split('T')[0];
        this.offlineBookingRequestFares.tripList.push(trip);
      }
      this.offlineBookingRequestFares.passengerList = this.offlineBookingRequestFares.passengerList.map(pax => {
        return { ...pax, agencyCurrency: localStorage.getItem("AgencyCurrency"), exchangeCurrencyRate: this.offlineBookingCreate.exchangeCurrencyRate }
      });

      this.buttonDisabled = true;
      this.loaderVar = true;
      this.offlineService.ApplyRevenueOnTicket(this.offlineBookingRequestFares).subscribe(res => {
        this.disabledFieldRevenue = true;
        this.offlineBookingRequestFares = res;
        this.buttonDisabled = false;
        this.loaderVar = false;
        for (let i = 0; i < this.offlineBookingRequestPassengers.length; i++) {
          if (this.offlineBookingRequestPassengers[i].passengerTypeId == 1) {
            this.offlineBookingRequestPassengers[i].serviceCharges = (Number(this.offlineBookingRequestFares.passengerFares[0].serviceFee.slice(3)) / this.offlineBookingRequestFares.passengerFares[0].count) + (this.offlineBookingRequestFares.passengerFares[0].serviceFeeValue / this.offlineBookingRequestFares.passengerFares[0].count) + (Number(this.offlineBookingRequestFares.passengerFares[0].markup.slice(3)) / this.offlineBookingRequestFares.passengerFares[0].count);
            this.offlineBookingRequestPassengers[i].discount = (Number(this.offlineBookingRequestFares.passengerFares[0].discount.slice(3)) / this.offlineBookingRequestFares.passengerFares[0].count) + (Number(this.offlineBookingRequestFares.passengerFares[0].discountValue) / this.offlineBookingRequestFares.passengerFares[0].count);
          }
          if (this.offlineBookingRequestPassengers[i].passengerTypeId == 2) {
            this.offlineBookingRequestPassengers[i].serviceCharges = (Number(this.offlineBookingRequestFares.passengerFares[1].serviceFee.slice(3)) / this.offlineBookingRequestFares.passengerFares[1].count) + (this.offlineBookingRequestFares.passengerFares[1].serviceFeeValue / this.offlineBookingRequestFares.passengerFares[1].count) + (Number(this.offlineBookingRequestFares.passengerFares[1].markup.slice(3)) / this.offlineBookingRequestFares.passengerFares[1].count);
            this.offlineBookingRequestPassengers[i].discount = (Number(this.offlineBookingRequestFares.passengerFares[1].discount.slice(3)) / this.offlineBookingRequestFares.passengerFares[1].count) + (Number(this.offlineBookingRequestFares.passengerFares[1].discountValue) / this.offlineBookingRequestFares.passengerFares[1].count);
          }
          if (this.offlineBookingRequestPassengers[i].passengerTypeId == 3) {
            this.offlineBookingRequestPassengers[i].serviceCharges = (Number(this.offlineBookingRequestFares.passengerFares[2].serviceFee.slice(3)) / this.offlineBookingRequestFares.passengerFares[2].count) + (this.offlineBookingRequestFares.passengerFares[2].serviceFeeValue / this.offlineBookingRequestFares.passengerFares[2].count) + (Number(this.offlineBookingRequestFares.passengerFares[2].markup.slice(3)) / this.offlineBookingRequestFares.passengerFares[2].count);
            this.offlineBookingRequestPassengers[i].discount = (Number(this.offlineBookingRequestFares.passengerFares[2].discount.slice(3)) / this.offlineBookingRequestFares.passengerFares[2].count) + (Number(this.offlineBookingRequestFares.passengerFares[2].discountValue) / this.offlineBookingRequestFares.passengerFares[2].count);
          }
          this.offlineBookingRequestPassengers[i].netFromCustomer = this.offlineBookingRequestPassengers[i].serviceCharges + this.offlineBookingRequestPassengers[i].fareValue + this.offlineBookingRequestPassengers[i].tax - this.offlineBookingRequestPassengers[i].discount;
          this.offlineBookingRequestPassengers[i].netToSupplier = this.offlineBookingRequestPassengers[i].fareValue + this.offlineBookingRequestPassengers[i].tax;
          this.CalculateRequestPassengerTotalAmountRevenue(i);
        }
      });
    }
  }


}
